
import React, {useState} from 'react';
import UserInformationPage1 from './UserInformationPage1.mjs';
import UserInformationPage2 from './UserInformationPage2.mjs';
import './UserInformation.css';

export default function UserInformation() 
{
    const [page_num, setPageNum] = useState(1); 
    const [page, setPage] = useState( <> <UserInformationPage1 /> </> );

    const show_page = (num) => { 

        if (page_num == num)
            return;

        switch (num)
        {
            case 1:
            default:
                setPage( <> <UserInformationPage1 /> </> ); 
                break;
            case 2:
                setPage( <> <UserInformationPage2 /> </> ); 
                break;
        }

        setPageNum(num);
    }

    return ( 
        <> 
            
            <div class="alert alert-light mt-2" role="alert">
                
                <nav className="py-0" aria-label="...">
                    <ul class="pagination pagination-sm justify-content-center">
                        <li class="page-item" onClick={ () => show_page(1) } aria-current="page">
                            <span class="page-link">intro</span>
                        </li>
                        <li class="page-item" onClick={ () => show_page(2) }><a class="page-link" href="#">icons</a></li>
                    </ul>
                </nav>

                <div className="user-info"><small>{page}</small></div>
            </div>
        </> 
    );
}

/*
                        <li class="page-item active" onClick={ () => show_page(1) } aria-current="page">


<em>Intentional Prioritization and recording new Action requests in your lower Lists will help you get things done.</em>


                    <p>Welcome! This is your, User Panel where you have a List of your Lists.</p>

                    <p>Why not just one list? Well, it's about prioritization and privacy. It starts with your Short List that contains a small set of Actions 
                       you have prioritized to work on right now. The idea is to move Actions from your private Long List and shared Team Lists to your Short List as you are
                       ready for them.</p>
                        
                       <p>Your private Long List is your personal list of things to do that are waiting to be moved to
                       your Short List. Your Long List Actions can not be shared with or viewed by other Users.</p>
                        
                       <p>Then you have your Team Lists. These Action Lists are intended to be shared within a team of users. These Actions are still 
                        private within the approved Team Members but no one else will have access to them. You can create a Team and invite new Members, send
                        a Join Request to an existing Team, or accept a Team Invitation. </p>

                    <div class="row">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/add.svg" alt="create team" border="0"/></a>
                        </div>
                        <div class="col">
                            To create a new Team, click on the Add Team icon. Enter your Team name, description, and action item prefix (up to 4 letters). 
                            The new Team will appear here in the User Panel.
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/request.svg" alt="join team" border="0"/></a>
                        </div>
                        <div class="col">
                            Users can send a Join-Request to a Team by clicking this icon to the left and entering the Team name. Then Team administrators
                            can decide whether to accept the request.
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/stg.svg" alt="stgs" border="0"/></a>
                        </div>
                        <div class="col">
                            Clicking on the Short-Term Goals icon will display the Team's current, shared Short-Term Goal and all Team Member action item assignments.
                        </div>
                    </div>

                    <div class="mt-2">
                        Enter a new action item above and click "Create" to get started!
                    </div>


*/